module.exports = __webpack_public_path__ + "static/maj-britt-1-116e8f93e6d086b2abaefc7236fdbe51.jpg";